import React, { useState, useEffect } from "react";

import { Link, useHistory, Redirect, useLocation } from "react-router-dom";
// material-ui
import { makeStyles } from "@material-ui/styles";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
// icons
import UserIcon from "@material-ui/icons/AccountCircle";
// components
import Loading from "components/Status/Loading";
import SnackbarContentWrapper from "components/Alerts/SnackbarAlert.js";

//Store
import { validateEmail } from "helpers/auth.helper";
import { parseQueryParams } from "utilities";
import config from "config";
import { useTitle } from 'react-use';
import { useAuth } from "contexts/auth-context";
import { checkAuthMethod } from "utils/auth-provider";
import { getItem, setItem } from "utils/localStorage";

//Track User Login
//import ReactGA from "react-ga4";

const useStyles = makeStyles((theme) => ({
	textField: {
		marginLeft: theme.spacing(),
		marginRight: theme.spacing(),
		width: 200,
	},
	menu: {
		width: 200,
	},
	button: {
		margin: theme.spacing(),
	},
	leftIcon: {
		marginRight: theme.spacing(),
	},
}));
function Login(props) {
	const { login, thirdPartyLogin, user } = useAuth();
	const history = useHistory();
	let {
		auth: { thirdPartyLogin: usesThirdPartyLogin },
	} = config;

	const { search, state, ...others } = useLocation();
	let query = parseQueryParams(search);

	const [email, setEmail] = useState(query?.get('email') || "");
	const [password, setPassword] = useState("");
	const [error, setError] = useState(null);
	const [notification, setNotification] = useState({
		open: false,
	});
	// Set Title
	useTitle(`Login to ${config.name}`);
	// const [loggingIn, setLoggingIn] = useState(false);
	const [showFirstPartyLogin, setShowFirstPartyLogin] = useState(false);
	const [showTermsConditions, setShowTermsConditions] = useState(false);
	const [stateTermsConditions, setState] = React.useState({
		stateTermsConditions: false,
	});
	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
	};
	const classes = useStyles();

	const { stateTermsConditionsCheckbox } = stateTermsConditions;

	function handleSubmit(event) {
		event.preventDefault();
		// ReactGA.event({
		// 	action: 'login_action',
		// 	category: 'login_category',
		// 	label: email,
		// });
		if (showFirstPartyLogin && stateTermsConditions.stateTermsConditions) {
			userLogin();
		} else {
			checkUserAuthMethod();
		}
	}

	function userLogin() {
		login({ email, password })
			.then((error) => {
				if (error) {
					console.error(error);
					setNotification({
						open: true,
						variant: "error",
						message:
							"There was an error when trying to login, please try again.",
						errorCode: 107,
					});
				} else {
					history.push(
						state?.initialPageRequest
							? state?.initialPageRequest?.pathname
							: "/dashboard/portfolio"
					);
				}
			})
			.catch((err) => {
				console.error(err);
				alert(err?.message ?? "Could not login");
			});
	}

	useEffect(() => {
		// Third Party Login
		if (query.has("ticket") && usesThirdPartyLogin) {
			const service = encodeURIComponent(
				window.location.origin + window.location.pathname
			);

			const ticket = query.get("ticket");

			thirdPartyLogin({
				service,
				ticket,
			})
				.then((error) => {
					// console.error(error);
					// if (error) {
					// 	setNotification({
					// 		open: true,
					// 		variant: "error",
					// 		message:
					// 			"There was an error when trying to login, please try again.",
					// 		errorCode: 107,
					// 	});
					// } else {
					// 	let { state: { initialPageRequest } = {} } = props.location;
					// 	history.push(
					// 		initialPageRequest ? initialPageRequest.pathname : "/dashboard"
					// 	);
					// }

					history.push(
						state?.initialPageRequest
							? state?.initialPageRequest?.pathname
							: "/dashboard/portfolio"
					);
				})
				.catch((err) => {
					alert("Could not login using third party authentication");
				});
		}
	}, [query, thirdPartyLogin]);
	useEffect(() => {
		if (
			!getItem("initialPageRequest") &&
			state?.initialPageRequest
		) {
			setItem(
				"initialPageRequest",
				JSON.stringify(state?.initialPageRequest)
			);
		}
	}, [state]);
	async function checkUserAuthMethod() {
		// Check if using third party auth service
		try {
			let { authMethod, checkTermsConditions, err } = await checkAuthMethod({ email });

			if ((checkTermsConditions === false) && (stateTermsConditions.stateTermsConditions === false)) {
				setShowTermsConditions(true);
				return;
			}

			if (checkTermsConditions === true) {
				setState({ stateTermsConditions: true })
			}

			if (authMethod === "first") {
				setShowFirstPartyLogin(true);
			} else if (authMethod === "third") {
				window.location.href = config.auth.thirdPartyLoginPath();
			} else {
				alert(err || "User not found. In order to be able to use the application, first sign up please.");
			}
		} catch (err) {
			console.error(err);
			alert("Incorrect Email");
		}
	}
	if (user) return <Redirect to={"/dashboard/portfolio"} />;
	return (query.has("ticket") && usesThirdPartyLogin) || error ? (
		<Loading error={error} />
	) : (
		<Grid container direction="row" justify="center" alignItems="center">
			<Grid item>
				<Card>
					<CardHeader title={`Login to ${config.name}`} />
					<CardContent>
						<form
							onSubmit={handleSubmit}
							className={classes.container}
							noValidate
							autoComplete="off"
						>
							<TextField
								autoFocus
								id="user-email"
								variant={"outlined"}
								label="Email"
								value={email}
								onChange={(event) => setEmail(event.target.value)}
								type="email"
								fullWidth
								margin="normal"
							/>
							{showFirstPartyLogin && stateTermsConditions.stateTermsConditions && (
								<TextField
									id="user-password"
									label="Password"
									value={password}
									variant={"outlined"}
									onChange={(event) => setPassword(event.target.value)}
									type="password"
									fullWidth
									autoFocus
									margin="normal"
								/>
							)}
							{showTermsConditions && (
								<FormControl required component="fieldset">
									<FormGroup>
										<FormControlLabel
											control={<Checkbox checked={stateTermsConditionsCheckbox} onChange={handleChange} name="stateTermsConditions" />}
											label={< Link to="/user/terms-conditions">I have read Terms and Conditions</Link>}
										/>
									</FormGroup>
									<FormHelperText error={!stateTermsConditions.stateTermsConditions}>You must agree Terms and Conditions</FormHelperText>
								</FormControl>
							)}
							<Button
								fullWidth
								variant="contained"
								color="primary"
								type="submit"
								disabled={!validateEmail(email)}
							>
								<UserIcon className={classes.leftIcon} />
								Login
							</Button>
						</form>
					</CardContent>
					<Divider light variant="middle" />
					<CardActions>
						<Grid container direction="row" justify="space-between" spacing={1}>
							{showFirstPartyLogin && (
								<Grid item>
									<Button
										aria-label="Login"
										component={Link}
										to="/user/forgot-password"
									>
										Forgot Password?
									</Button>
								</Grid>
							)}
							<Grid item>
								<Button
									aria-label="Login"
									component={Link}
									to="/user/signup"
								>
									New UMD Users Sign Up
								</Button>
							</Grid>
						</Grid>
					</CardActions>
				</Card>
				{notification.open && (
					<SnackbarContentWrapper
						{...notification}
						onClose={() => setNotification({ open: false })}
					/>
				)}
			</Grid>
		</Grid >
	);
}

export default Login;
